import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { IoCloseOutline } from "react-icons/io5";
import EditableText from "../../components/conedit";

export default function Sev2({ OnClose }) {
  const { user, chatData } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(OnClose, 300);
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ height: "100%" }}
    >
      <div className="h-full">
        {/* HEADER & TABS */}
        <div className="mb-4" style={{ backgroundColor: "rgb(22, 19, 22)" }}>
          <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
            <div className="flex justify-start">
              <button className=" text-gray-200" onClick={handleClose}>
                <IoCloseOutline size={33} />
              </button>
            </div>
            <div className="mx-auto">
              <div className="flex items-center justify-center gap-1">
                <p className="text-md font-medium text-gray-200">
                  Transfer Authorization
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="border flex flex-col items-center justify-center gap-36 px-10"
          style={{ height: "90vh" }}
        >
          <div className="text-center flex flex-col items-center justify-center">
            <p className="text-blue-600 font-semibold mb-4">
              TRANSFER SUSPENDED
            </p>
            <p className="text-sm">
              The ticket(s) transfer to the email below has been suspended for
              certain security breaches
            </p>

            <p className="text-sm">Contact support for more information</p>

            <p
              contentEditable
              suppressContentEditableWarning={true}
              spellCheck={false}
              className="text-lg overflow-hidden text-ellipsis font-semibold mt-3 text-blue-600"
            >
              mailer here
            </p>
          </div>
          <div className="w-10/12 p-2 rounded-lg bg-blue-600 mt-36 text-center text-white font-medium text-lg">
            <p>Contact Support</p>
          </div>
        </div>
      </div>
    </div>
  );
}
